module.exports = __webpack_public_path__ + "img/carshina21_20.6badcf99.jpg";